import { enableProdMode, importProvidersFrom } from "@angular/core";

import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CurrencyMaskDirective } from "./app/shared/directive/currency-mask.directive";
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from "ngx-mask";
import { AppRoutingModule } from "./app/app-routing.module";
import { AppComponent } from "./app/app.component";
import { ApiService } from "./app/core/apis/util/api.service";
import { AuthService } from "./app/core/auth/service/auth.service";
import { Globals } from "./app/shared/helpers/globals";
import { environment } from "./environments/environment";
import { datadogRum } from "@datadog/browser-rum";
import packageJson from "../package.json";
import { RouteGuardService } from "./app/core/guard/route-guard.service";

// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

if (environment.production) {
  enableProdMode();
}

datadogRum.onReady(function () {
  datadogRum.init({
    applicationId: "510a13ef-5d37-455d-acf8-2a52583aa2f0",
    clientToken: "pub42bf904de888e0b56327515c7e1abcec",
    site: 'datadoghq.com',
    service: packageJson.name,
    env: environment.production ? 'prod' : 'uat',
    version: packageJson.version,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 5,
    defaultPrivacyLevel: 'allow',
  });

  datadogRum.setGlobalContextProperty('team', 'brazil_data_strategy_-_concentrados');
  datadogRum.setGlobalContextProperty('coststring', '1800.BQ.100.502059');
  datadogRum.setGlobalContextProperty('businessservice', 'Concentrados');
});

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      ReactiveFormsModule,
      MatExpansionModule,
      MatMenuModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatSelectModule,
      MatRadioModule,
      MatTableModule,
      MatButtonModule,
      MatCheckboxModule,
      MatToolbarModule,
      MatProgressSpinnerModule,
      MatDividerModule,
      MatTabsModule,
      MatPaginatorModule,
      MatAutocompleteModule,
      MatTooltipModule,
      MatInputModule,
      MatIconModule,
      MatSnackBarModule,
      FormsModule,
      CurrencyMaskDirective,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      NgxMaskDirective,
      NgxMaskPipe
    ),
    ApiService,
    MatDatepickerModule,
    Globals,
    AuthService,
    RouteGuardService,
    provideEnvironmentNgxMask(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    // TODO - revisar necessidade de interceptor
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterceptor,
    //   multi: true,
    // }
  ],
}).catch((err) => console.error(err));
